import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ConfigService, EntityService, User } from 'viggo-sistemas-core-web';

// FIXME: TROUXE UMA CLASSE DE SERVIÇO QUE É O ESPELHO DO INFOSYSTEM
// É SO VERIFICAR SE VAI PRECISAR DESSA FUNÇÃO NO INFOSYSTEM SE FOR LEVA ELA PRA LA
@Injectable()
export class UserDisponivelService extends EntityService<User> {
  constructor(protected configService: ConfigService) {
    super(
      {
        baseEntityEndPoint: 'user',
        urlBackend: configService.backendURL
      }
    );
  }

  /**
   * Responsável por resgatar os usuários disponíveis
   * @param cliente_id
   * @param domain_id
   * @param include
   * @param pagination
   * @param order_by
   * @param where
   * @returns
   */
  public usuariosDisponiveis(
    domain_id: string,
    user_id?: string,
    include?: string[],
    pagination?: {
      require_pagination?: boolean;
      page_size?: number;
      page?: number;
    },
    order_by?: string,
    where?: { field: string; value: string }
  ): Observable<any> {
    const url = `${this.baseURL}/disponiveis`;
    let params = new HttpParams();

    if (domain_id) {
      params = params.append('domain_id', domain_id);
    }

    if (user_id) {
      params = params.append('user_id', user_id);
    }

    if (include) {
      params = params.append('include', include.join(','));
    }

    if (pagination) {
      params = params
        .append('require_pagination', pagination.require_pagination)
        .append('page_size', pagination.page_size)
        .append('page', pagination.page);
    }

    if (Object.keys(where).length !== 0) {
      params = params.append(`${where.field}`, where.value);
    }

    if (order_by) {
      params = params.append('order_by', order_by);
    }

    return this.http.get<any>(url, {
      headers: this.getHeader(),
      params
    });
  }
}
